<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label aria-label="local esign host">
                    {{ t_local_esign_host }}
                    <input v-model="localHostUrl"
                           :placeholder="publicHostUrl"
                           class="form-control"
                           name="esign_local_host"
                           type="text"
                           aria-label="local esign host input">
                </label>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label aria-label="public esign host">
                    {{ t_public_esign_host }}
                    <input v-model="publicHostUrl"
                           class="form-control"
                           name="esign_public_host"
                           type="text"
                           aria-label="public esign host input">
                </label>
            </div>
        </div>
    </div>
    <!--    <div class="row">
            <div class="col-md-12 p-m">&nbsp;</div>
        </div>-->
</template>

<script>
export default {
    name: "tab-esign",

    data: function () {
        return {
            t_local_esign_host: Lang.langGet("Local eSign Host"),
            t_public_esign_host: Lang.langGet("Public eSign Host"),

            localHostUrl: "",
            publicHostUrl: "",
        }
    },
    mounted() {
        EaseEventBus.listen('reset-esign-tab', () => {
            this.localHostUrl = '';
            this.publicHostUrl = '';
        });
    }
}
</script>
